<template>
  <div>
    <PLoader v-if="isLoading" />

    <p v-else-if="!post">No Post for this ID.</p>

    <div v-else class="p-4 bg-white radius-1 border-1 border-gray-4">
      <div v-if="isPreview" v-html="post.image"></div>

      <h3 v-if="isPreview">{{ post.title }}</h3>
      <h1 v-else>{{ post.title }}</h1>

      <div v-if="!isPreview" v-html="post.image"></div>

      <p>
        <strong>{{ post.bonus_amount | number }} {{ post.bonus_type }} </strong>
        <span>
          after you spend ${{ post.minimum_spend | number }}
          <template v-if="+post.timeframe">
            in {{ post.timeframe }} months
          </template>
        </span>
      </p>

      <p>Annual Fee: ${{ post.annual_fee }}</p>

      <div v-if="!isPreview" v-html="post.content"></div>

      <div v-if="isPreview" class="flex justify-between">
        <a :href="post.application_url" target="_blank">Apply Now</a>
        <router-link :to="'/card-' + post.id">More Details</router-link>
      </div>

      <p v-else class="h4 text-center">
        <a :href="post.application_url" target="_blank">Apply</a>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: ["details", "id", "preview"],

  data() {
    return {
      isLoading: false,
      post: null
    };
  },

  computed: {
    isPreview() {
      return this.preview !== undefined;
    }
  },

  async created() {
    if (this.details) {
      this.post = this.details;
      return;
    }
    if (!this.id) return;

    try {
      this.isLoading = true;

      // TODO: Only fetch individual post details
      const allPosts = await fetch(
        "https://perxapp.com/wp-json/perx/v1/cards",
        {
          method: "get",
          headers: {
            Accept: "application/json"
          }
        }
      ).then(response => response.json());

      this.post = allPosts.find(item => item.id === parseInt(this.id));
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log(err);
    } finally {
      this.isLoading = false;
    }
  }
};
</script>
